// JWT timing settings
// All timings are in seconds

export type OrgJwtTimings = {
  ACCESS_TOKEN_EXPIRY: number // How long the JWT access token is valid
  REFRESH_TOKEN_EXPIRY: number // Maximum period of inactivity before re-login required
  SESSION_REFRESH_INTERVAL: number // How long before expiry to trigger proactive refresh
}

export const DEFAULT_TIMINGS: OrgJwtTimings = {
  ACCESS_TOKEN_EXPIRY: 60 * 60, // 1 hour
  REFRESH_TOKEN_EXPIRY: 7 * 24 * 60 * 60, // 7 days
  SESSION_REFRESH_INTERVAL: 10 * 60, // 10 minutes
}

const HIGH_SECURITY_TIMINGS: OrgJwtTimings = {
  ACCESS_TOKEN_EXPIRY: 15 * 60, // 15 minutes
  REFRESH_TOKEN_EXPIRY: 6 * 60 * 60, // 6 hours
  SESSION_REFRESH_INTERVAL: 5 * 60, // 5 minutes
}

const LOCAL_TEST_TIMINGS: OrgJwtTimings = {
  ACCESS_TOKEN_EXPIRY: 60, // 1 minute
  REFRESH_TOKEN_EXPIRY: 180, // 3 minutes
  SESSION_REFRESH_INTERVAL: 15, // 15 seconds
}

// Add organisation IDs here that need custom JWT timing settings
const ORG_OVERRIDES: Record<string, OrgJwtTimings> = {
  'dec13358-3913-408b-a615-02cebd83ae37': HIGH_SECURITY_TIMINGS, // Entrust [Prod EU]
  'bf2a655c-96a9-4c61-9df9-e3c9829b05f2': HIGH_SECURITY_TIMINGS, // Entrust QA [Prod EU]
  '1f4fde6d-4eaa-4313-8482-8f1b6f1fdb20': LOCAL_TEST_TIMINGS, // Brian Local
  '33753a5f-c782-4392-a725-83ebad8ac246': LOCAL_TEST_TIMINGS, // Brian Sandbox [Styx]
  '08b07a1c-21e1-4e83-a130-b9334bd993fa': LOCAL_TEST_TIMINGS, // Brian Sandbox [Staging]
}

const currentTimeInSeconds = () => Math.floor(Date.now() / 1000)

export const getIssuedAt = () => currentTimeInSeconds()

export const getAccessTokenExpirationTime = (customExpiry?: number) =>
  currentTimeInSeconds() + (customExpiry ?? DEFAULT_TIMINGS.ACCESS_TOKEN_EXPIRY)

export const getRefreshTokenExpirationTime = (customExpiry: number) => currentTimeInSeconds() + customExpiry

export const getOrgJwtTimings = (orgId: string): OrgJwtTimings => {
  return ORG_OVERRIDES[orgId] ?? DEFAULT_TIMINGS
}
